var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var _pendingRequestUrl, _abortController, _VariantPicker_instances, isOnProductTemplate_get, usesSectionRendering_get;
import { a0 as VariantPickerSelectedEvent, a1 as VariantPickerUpdateEvent, J as morph, q as activateInteractionAssets } from "./utilities-Da0sjanJ.js";
class VariantPicker extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _VariantPicker_instances);
    __privateAdd(this, _pendingRequestUrl);
    __privateAdd(this, _abortController);
  }
  connectedCallback() {
    this.addEventListener("change", this.variantSelected.bind(this));
  }
  variantSelected(event) {
    var _a;
    if (!(event.target instanceof HTMLElement)) return;
    let selectedOption = event.target;
    if (event.target instanceof HTMLSelectElement) {
      const selectedIndex = event.target.selectedIndex;
      selectedOption = event.target.options[selectedIndex];
      if (!selectedOption) return;
    }
    this.updateSelectedOption(event.target);
    this.dispatchEvent(new VariantPickerSelectedEvent({ id: selectedOption.dataset.optionValueId ?? "" }, { productId: this.dataset.productId }));
    const currentUrl = (_a = this.dataset.productUrl) == null ? void 0 : _a.split("?")[0];
    const newUrl = selectedOption.dataset.connectedProductUrl || event.target.dataset.connectedProductUrl;
    const loadsNewProduct = __privateGet(this, _VariantPicker_instances, isOnProductTemplate_get) && !!newUrl && newUrl !== currentUrl;
    this.handleStandardVariantSelection(event.target, loadsNewProduct);
    if (__privateGet(this, _VariantPicker_instances, isOnProductTemplate_get)) {
      this.updateUrlForVariant(event.target, newUrl, loadsNewProduct);
    }
  }
  /**
   * Handle variant selection for standard context (product page, quick view, etc.)
   * @param {HTMLElement} selectedOption
   * @param {boolean} loadsNewProduct
   */
  handleStandardVariantSelection(selectedOption, loadsNewProduct) {
    this.fetchUpdatedSection(this.buildRequestUrl(selectedOption), loadsNewProduct);
  }
  /**
   * Update browser URL for variant selection (product page only)
   * @param {HTMLElement} selectedOption
   * @param {string|null} newUrl
   * @param {boolean} loadsNewProduct
   */
  updateUrlForVariant(selectedOption, newUrl, loadsNewProduct) {
    const url = new URL(window.location.href);
    let variantId;
    if (selectedOption instanceof HTMLInputElement && selectedOption.type === "radio") {
      variantId = selectedOption.dataset.variantId || null;
    } else if (selectedOption instanceof HTMLSelectElement) {
      const option = selectedOption.options[selectedOption.selectedIndex];
      variantId = (option == null ? void 0 : option.dataset.variantId) || null;
    }
    if (variantId) {
      url.searchParams.set("variant", variantId);
    } else {
      url.searchParams.delete("variant");
    }
    if (loadsNewProduct) {
      url.pathname = newUrl;
    }
    if (url.href !== window.location.href) {
      history.replaceState({}, "", url.toString());
    }
  }
  fetchUpdatedSection(requestUrl, shouldMorphMain = false) {
    var _a;
    (_a = __privateGet(this, _abortController)) == null ? void 0 : _a.abort();
    __privateSet(this, _abortController, new AbortController());
    fetch(requestUrl, { signal: __privateGet(this, _abortController).signal }).then((response) => this.parseResponse(response)).then((data) => this.processResponseData(data)).then((responseText) => this.handleResponse(responseText, shouldMorphMain)).catch((error) => {
      if (error.name === "AbortError") ;
      else {
      }
    });
  }
  /**
   * Parse fetch response based on context
   * @param {Response} response
   * @returns {Promise<Object|string>}
   */
  parseResponse(response) {
    if (this.dataset.productQuickViewUrl || this.dataset.productQuickAddUrl || __privateGet(this, _VariantPicker_instances, usesSectionRendering_get)) {
      return response.json();
    } else {
      return response.text();
    }
  }
  /**
   * Process response data based on context
   * @param {Object|string} data
   * @returns {string}
   */
  processResponseData(data) {
    if (typeof data === "object") {
      if (__privateGet(this, _VariantPicker_instances, usesSectionRendering_get)) {
        return data[this.dataset.sectionId];
      }
      return data["sc_main_product_quick_view"];
    } else {
      return data;
    }
  }
  /**
   * Handle response and dispatch appropriate events
   * @param {string} responseText
   * @param {boolean} shouldMorphMain
   */
  handleResponse(responseText, shouldMorphMain) {
    var _a;
    __privateSet(this, _pendingRequestUrl, void 0);
    const html = new DOMParser().parseFromString(responseText, "text/html");
    (_a = html.querySelector("overflow-list[defer]")) == null ? void 0 : _a.removeAttribute("defer");
    this.handleStandardResponse(html, shouldMorphMain);
  }
  /**
   * Handle response for standard context (product page, quick view, etc.)
   * @param {Document} html
   * @param {boolean} shouldMorphMain
   */
  handleStandardResponse(html, shouldMorphMain) {
    var _a;
    const tag = this.tagName.toLowerCase();
    let pickerSelector = tag;
    if (this.dataset.sectionId) {
      pickerSelector = `${tag}[data-section-id="${this.dataset.sectionId}"]`;
      if (this.dataset.productId) {
        pickerSelector += `[data-product-id="${this.dataset.productId}"]`;
      }
      if (this.dataset.blockId) {
        pickerSelector += `[data-block-id="${this.dataset.blockId}"]`;
      }
    } else if (this.dataset.productId) {
      pickerSelector = `${tag}[data-product-id="${this.dataset.productId}"]`;
    }
    const textContent = (_a = html.querySelector(`${pickerSelector} script[type="application/json"]`)) == null ? void 0 : _a.textContent;
    if (!textContent) return;
    if (shouldMorphMain) {
      this.updateMain(html);
    } else {
      const newProduct = this.updateVariantPicker(html);
      if (this.selectedOptionId) {
        this.dispatchEvent(
          new VariantPickerUpdateEvent(JSON.parse(textContent), this.selectedOptionId, {
            html,
            productId: this.dataset.productId ?? "",
            newProduct
          })
        );
      }
    }
  }
  updateVariantPicker(newHtml) {
    let newProduct;
    const tag = this.tagName.toLowerCase();
    let selector = tag;
    if (this.dataset.sectionId) {
      selector = `${tag}[data-section-id="${this.dataset.sectionId}"]`;
      if (this.dataset.productId) {
        selector += `[data-product-id="${this.dataset.productId}"]`;
      }
      if (this.dataset.blockId) {
        selector += `[data-block-id="${this.dataset.blockId}"]`;
      }
    } else if (this.dataset.productId) {
      selector = `${tag}[data-product-id="${this.dataset.productId}"]`;
    }
    const newVariantPicker = newHtml.querySelector(selector);
    if (!newVariantPicker) {
      throw new Error("No new variant picker source found");
    }
    if (newVariantPicker instanceof HTMLElement) {
      const newProductId = newVariantPicker.dataset.productId;
      const newProductUrl = newVariantPicker.dataset.productUrl;
      const newProductQuickViewUrl = newVariantPicker.dataset.productQuickViewUrl;
      const newProductQuickAddUrl = newVariantPicker.dataset.productQuickAddUrl;
      if (newProductId && newProductUrl && this.dataset.productId !== newProductId) {
        newProduct = { id: newProductId, url: newProductUrl };
      }
      if (newProductId) {
        this.dataset.productId = newProductId;
      }
      if (newProductUrl) {
        this.dataset.productUrl = newProductUrl;
      }
      if (newProductQuickViewUrl) {
        this.dataset.productQuickViewUrl = newProductQuickViewUrl;
      }
      if (newProductQuickAddUrl) {
        this.dataset.productQuickAddUrl = newProductQuickAddUrl;
      }
    }
    morph(this, newVariantPicker);
    activateInteractionAssets(this);
    return newProduct;
  }
  updateMain(newHtml) {
    const main = document.querySelector("main");
    const newMain = newHtml.querySelector("main");
    if (!main || !newMain) {
      throw new Error("No new main source found");
    }
    morph(main, newMain);
    activateInteractionAssets(main);
  }
  buildRequestUrl(selectedOption, source = null, sourceSelectedOptionsValues = []) {
    let connectedProductUrl = null;
    if (selectedOption instanceof HTMLSelectElement) {
      const selectedIndex = selectedOption.selectedIndex;
      const option = selectedOption.options[selectedIndex];
      connectedProductUrl = option == null ? void 0 : option.dataset.connectedProductUrl;
    } else {
      connectedProductUrl = selectedOption.dataset.connectedProductUrl;
    }
    let productUrl = connectedProductUrl || __privateGet(this, _pendingRequestUrl) || this.dataset.productUrl || this.dataset.productQuickViewUrl || this.dataset.productQuickAddUrl;
    __privateSet(this, _pendingRequestUrl, productUrl);
    const params = [];
    if (this.selectedOptionsValues.length && !source) {
      params.push(`option_values=${this.selectedOptionsValues.join(",")}`);
    }
    if (__privateGet(this, _VariantPicker_instances, usesSectionRendering_get)) {
      params.push(`sections=${this.dataset.sectionId}`);
    }
    if (this.dataset.productQuickViewUrl || this.dataset.productQuickAddUrl) {
      return `${productUrl}&${params.join("&")}`;
    } else {
      return `${productUrl}?${params.join("&")}`;
    }
  }
  updateSelectedOption(target) {
    if (typeof target === "string") {
      const targetElement = this.querySelector(`[data-option-value-id="${target}"]`);
      if (!targetElement) throw new Error("Target element not found");
      target = targetElement;
    }
    if (target instanceof HTMLInputElement) {
      target.checked = true;
    }
    if (target instanceof HTMLSelectElement) {
      const newValue = target.value;
      const newSelectedOption = Array.from(target.options).find((option) => option.value === newValue);
      if (!newSelectedOption) throw new Error("Option not found");
      for (const option of target.options) {
        option.removeAttribute("selected");
      }
      newSelectedOption.setAttribute("selected", "selected");
      if (newValue) {
        target.setAttribute("selected", "");
      } else {
        target.removeAttribute("selected");
      }
    }
  }
  get selectedOptionId() {
    const selectedOption = this.querySelector("select option[selected], fieldset input:checked");
    if (!(selectedOption instanceof HTMLInputElement || selectedOption instanceof HTMLOptionElement)) {
      return void 0;
    }
    return selectedOption;
  }
  get selectedOptionsValues() {
    const selectedOptions = Array.from(this.querySelectorAll("select option[selected], fieldset input:checked"));
    return selectedOptions.map((option) => {
      const { optionValueId } = option.dataset;
      if (!optionValueId) throw new Error("No option value ID found");
      return optionValueId;
    });
  }
}
_pendingRequestUrl = new WeakMap();
_abortController = new WeakMap();
_VariantPicker_instances = new WeakSet();
isOnProductTemplate_get = function() {
  return Theme.template.name === "product";
};
usesSectionRendering_get = function() {
  return !__privateGet(this, _VariantPicker_instances, isOnProductTemplate_get) && !!this.dataset.sectionId;
};
if (!customElements.get("variant-picker")) {
  customElements.define("variant-picker", VariantPicker);
}
